import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=38ee4298&scoped=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=38ee4298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee4298",
  null
  
)

export default component.exports